export const POLICY = {
  nickname: 'PRODUCTS.POLICY.shortname',
  isHidden: true,
  icon:'policy'
};
